import React from 'react';
import { Dialog, DialogContent, Typography, Box, Button } from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import { motion, AnimatePresence } from 'framer-motion';

const SuccessModal = ({ open, handleClose, title, message }) => {
  return (
    <AnimatePresence>
      {open && (
        <Dialog
          open={open}
          onClose={handleClose}
          PaperComponent={motion.div}
          PaperProps={{
            initial: { scale: 0.8, opacity: 0 },
            animate: { scale: 1, opacity: 1 },
            exit: { scale: 0.8, opacity: 0 },
            transition: { duration: 0.3 },
            sx: {
              borderRadius: '24px',
              boxShadow: '0 20px 60px rgba(0,0,0,0.18)',
              padding: { xs: '24px', md: '40px' },
              textAlign: 'center',
              maxWidth: '500px',
              width: '90%',
              bgcolor: '#ffffff',
              overflow: 'hidden'
            },
          }}
          BackdropProps={{
            sx: {
              backgroundColor: 'rgba(255,255,255,0.02)',
              backdropFilter: 'none',
            },
          }}
        >
          <DialogContent sx={{ p: 0 }}>
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <CheckCircleOutlineIcon 
                sx={{ 
                  fontSize: 80, 
                  color: '#4caf50', 
                  mb: 3 
                }} 
              />
              <Typography 
                variant="h4" 
                sx={{ 
                  fontWeight: 'bold', 
                  mb: 2, 
                  color: '#1E40AF',
                  fontSize: { xs: '1.5rem', md: '1.8rem' },
                  lineHeight: 1.2
                }}
              >
                {title || "Message Sent Successfully"}
              </Typography>
              <Typography 
                variant="body1" 
                sx={{ 
                  color: '#666', 
                  mb: 4,
                  fontSize: '1.1rem',
                  lineHeight: 1.5
                }}
              >
                {message}
              </Typography>
              <Button
                fullWidth
                variant="contained"
                onClick={handleClose}
                sx={{
                  borderRadius: '12px',
                  px: { xs: 4, sm: 8 },
                  py: 1.5,
                  backgroundColor: '#1E3A8A',
                  '&:hover': {
                    backgroundColor: '#1E40AF',
                  },
                  textTransform: 'none',
                  fontSize: '1.1rem',
                  fontWeight: 'bold',
                  boxShadow: '0 4px 12px rgba(30, 58, 138, 0.25)'
                }}
              >
                OK
              </Button>
            </Box>
          </DialogContent>
        </Dialog>
      )}
    </AnimatePresence>
  );
};

export default SuccessModal;
